import React from 'react';
import { RadioGroup } from 'react-form';

import {
    RadioButton,
} from '../../../../Form';
import withStatsig from '../../../../hocs/withStatsig';
import { required } from '../../../../../utils/validation';
import { acceptanceRankingValues } from '../../../../../utils/eventConstants';

const AcceptanceRankTypeSelect = (props) => {
    const {
        field,
        divisionIndex,
        isDivisionGenderMaleOrFemale,
        isDivisionGenderFemale,
        isPTTEvent,
        onChange,
        checkGate,
        featureGates,
    } = props;

    const isPTTWTAAcceptanceListEnabled = checkGate(featureGates.PTT_WTA_ACCEPTANCE_LIST);

    return (
        <>
            <label>How would you sort player acceptance</label>
            <RadioGroup
                field={[field, divisionIndex, 'acceptance', 'list', 'type']}
                validate={required}
                onChange={onChange}
            >
                {isPTTEvent && isDivisionGenderMaleOrFemale && (
                    <RadioButton
                        key={'acceptance-list-type-PTT'}
                        label="PTT Rank"
                        value={acceptanceRankingValues.PTT}
                        id={`division-${divisionIndex}-ptt`}
                    />
                )}
                <RadioButton
                    key={'acceptance-list-type-utr'}
                    label="UTR Rating"
                    value={acceptanceRankingValues.UTR}
                    id={`division-${divisionIndex}-utr`}
                />
                {isPTTEvent && isDivisionGenderFemale && isPTTWTAAcceptanceListEnabled && (
                    <RadioButton
                        key={'acceptance-list-type-WTA'}
                        label="WTA"
                        value={acceptanceRankingValues.WTA}
                        id={`division-${divisionIndex}-wta`}
                    />
                )}
            </RadioGroup>
        </>
    );
};

export default withStatsig(AcceptanceRankTypeSelect);
